import { BlurAttribute } from '../interfaces/iblur-attribute';
import { BlurClass } from '../interfaces/iblur-class';
import { BlurAria } from '../interfaces/iblur-aria';
import { SliderInfo } from '../interfaces/islider-info';

export class NextPagePropertiesModel {
    public resizing = false;
    public lastResize = -1;
    public resizeKeys: string[] = [];
    public sliderInfo: Record<string, SliderInfo> = {};
    public isMobile = false;
    public isTablet = false;
    public lastLayoutWidth: number;
    public disabledAlerts: Record<string, number>;
    public blurAttributes: Array<BlurAttribute>;
    public blurClasses: Array<BlurClass>;
    public blurAria: Array<BlurAria>;

    constructor() {
        this.disabledAlerts = JSON.parse(localStorage.getItem('disableAlerts') || '{}');
        this.blurAttributes = new Array<BlurAttribute>();
        this.blurClasses = new Array<BlurClass>();
        this.blurAria = new Array<BlurAria>();
    }
}
